import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path-globe",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_1059",
			"data-name": "Rectangle 1059",
			width: 33.896,
			height: 33.896,
			fill: "none",
			stroke: "#7284fa",
			strokeWidth: 1
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_14548",
		"data-name": "Group 14548",
		transform: "translate(-611 -143)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_11788",
			"data-name": "Group 11788",
			transform: "translate(611 143)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39239",
				"data-name": "Path 39239",
				d: "M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z",
				fill: "#fff",
				opacity: .815
			})
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_12194",
			"data-name": "Group 12194",
			transform: "translate(625 156)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_3478",
				"data-name": "Group 3478",
				transform: "translate(-1 0)",
				clipPath: "url(#clip-path-globe)",
				children: [
					/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse_96",
						"data-name": "Ellipse 96",
						cx: 10.016,
						cy: 10.016,
						rx: 10.016,
						ry: 10.016,
						transform: "translate(6.925 6.932)",
						fill: "#dad9ef",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_3106",
						"data-name": "Path 3106",
						d: "M20.69,7.616a4.973,4.973,0,0,1-2.177,3.262C14.474,9.869,16,12.154,16.336,13.493c.436.435,1.305,0,1.305,0,1.948,3.832-1.305,4.789-1.305,4.789-2.37,2.37-1.6,3.046-3.918,3.046-.436,0-1.308-1.738-1.308-2.177,0-3.317-1.663-3.918-3.046-3.918-1.307,0-1.307-1.74-1.307-1.74s0-3.051,2.176-3.485,2.177.435,2.177.435c.9.9,4.089-.864,1.176-3.133-1.077-.84,3.932-2.529,3.932-2.529",
						transform: "translate(3.654 2.586)",
						fill: "#dad9ef",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_3107",
						"data-name": "Path 3107",
						d: "M22.577,3.259,16.538,2.071l.468,5.2",
						transform: "translate(8.945 1.12)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_3108",
						"data-name": "Path 3108",
						d: "M1.006,20.31l6.88,1.438-.555-5.187",
						transform: "translate(0.544 8.957)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_3109",
						"data-name": "Path 3109",
						d: "M20.728,2.071A16.182,16.182,0,0,1,8.759,31.636",
						transform: "translate(4.737 1.12)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_3110",
						"data-name": "Path 3110",
						d: "M8.16,30.434A16.183,16.183,0,0,1,20.1.862",
						transform: "translate(0.27 0.27)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					})
				]
			})
		})]
	})]
});
export default SvgGlobe;
